export default __webpack_public_path__ + "static/media/WorkSans-Medium.f292ced0.ttf";